export function externalShipmentAffProductScannedValidate(scanned) {
    var result = true; 
    var errors = [];

    result = validateType(scanned.type, errors);
    result = validateProductId(scanned.product_id, errors);
    result = validateDetailedStockId(scanned.detailed_stock_id, errors);
    result = validateLocationId(scanned.location_id, errors);
    result = validateLocationCompleted(scanned.location_completed, errors);
    result = validateSessionCompleted(scanned.session_completed, errors);
    result = validateScanned(scanned.scanned, errors);
    result = validateRequired(scanned.required, errors);
    
    if(!result) return errors;
    else return result;
}

function validateType(type, errors) {
    if(typeof type === 'string' && type.trim() !== '') return true;
    else {
        errors.push("type_not_valid");
        return false;
    } 
}

function validateProductId(product_id, errors){    
    if(Number.isInteger(product_id)) return true;
    else { 
        errors.push("product_id_not_valid");
        return false;
    }
}

function validateDetailedStockId(detailed_stock_id, errors){    
    if(Number.isInteger(detailed_stock_id)) return true;
    else { 
        errors.push("detailed_stock_id_not_valid");
        return false;
    }
}

function validateLocationId(location_id, errors){    
    if(Number.isInteger(location_id)) return true;
    else { 
        errors.push("location_id_not_valid");
        return false;
    }
}

function validateLocationCompleted(location_completed, errors) {
    if(typeof location_completed === "boolean") return true;
    else {
        errors.push("location_completed_not_valid");
        return false;
    }
}

function validateSessionCompleted(session_completed, errors) {
    if(typeof session_completed === "boolean") return true;
    else {
        errors.push("session_completed_not_valid");
        return false;
    }
}

function validateScanned(scanned, errors){    
    if(Number.isInteger(scanned)) return true;
    else { 
        errors.push("scanned_not_valid");
        return false;
    }
}

function validateRequired(required, errors){    
    if(Number.isInteger(required)) return true;
    else { 
        errors.push("required_not_valid");
        return false;
    }
}